import { AloftTime } from '@aloft/shared-objects';
import { RevisionData } from '@aloft/toolkit-shared';
import { Flex, Icon, Link, Typography } from '@aloft/toolkit-sui';
import { ListItem, UnorderedList } from '@aloft/toolkit-sui/chakra';
import { getRevisionRequestUrl } from './getRevisionRequestUrl.ts';

export const RevisionRequestContent = ({
  revisionData,
}: {
  revisionData: RevisionData;
}) => {
  const url = getRevisionRequestUrl(revisionData.inspectionId ?? '', revisionData.revisionRequestId ?? '');
  const requestedAt = AloftTime.schema.parse(revisionData.requestedAt);

  return (
    <Flex marginTop="1rem" marginBottom="2rem" flexDirection="column" gap="10px">
      <Typography variant="body1" color="textSecondary"><span style={{ fontWeight: 'bold' }}>Date & Time:&nbsp;</span>
        {requestedAt.formatTime(undefined, 'MM/dd hh:mm aa')}
      </Typography>
      <Typography variant="body1" color="textSecondary"><span style={{ fontWeight: 'bold' }}>Description:&nbsp;</span>
        {revisionData.requestDescription}
      </Typography>
      <Flex marginY="10px">
        <Link href={url} isExternal>
          <Flex alignItems="center" gap="5px">
            <Icon icon="download" />
            <Typography variant="h4">View Document</Typography>
          </Flex>
        </Link>
      </Flex>
      {revisionData.comparables?.map((comp, compIndex) => (
        <Flex key={comp.address} marginTop="0.5rem" flexDirection="column" gap="5px">
          <Typography variant="body1" color="textSecondary">
            <span style={{ fontWeight: 'bold' }}>Alternative Comparable {compIndex + 1}</span>
          </Typography>
          <UnorderedList paddingLeft="10px">
            <ListItem>
              <Typography variant="body1" color="textSecondary">
                <span style={{ fontWeight: 'bold' }}>Address:&nbsp;</span>
                {comp.address}
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="body1" color="textSecondary">
                <span style={{ fontWeight: 'bold' }}>Date of Sale:&nbsp;</span>
                {comp.dateOfSale}
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="body1" color="textSecondary">
                <span style={{ fontWeight: 'bold' }}>Data Source:&nbsp;</span>
                {comp.dataSource}
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="body1" color="textSecondary">
                <span style={{ fontWeight: 'bold' }}>Rationale for consideration:&nbsp;</span>
                {comp.justification}
              </Typography>
            </ListItem>
          </UnorderedList>
        </Flex>
      ))}
    </Flex>
  );
}
